import * as React from 'react';
import * as styles from './CarouselGraphics.module.scss';

class CarouselGraphics extends React.Component {
  state = {
    selected: 0,
    intervalId: '',
    isSetInterval: false
  };

  //AUTOMATIC SWITCHING OF SLIDES

  componentWillUnmount() {
    this.clearSlidesInterval();
  }

  componentDidUpdate(prevProps) {
    const { isSetInterval } = this.state;
    const { isVisible } = this.props;

    if (prevProps.isVisible !== isVisible) {
      if (isVisible && !isSetInterval) {
        this.setSlidesInterval();
      } else if (!isVisible) {
        this.clearSlidesInterval();
      }
    }
  }

  setSlidesInterval() {
    const intervalId = setInterval(() => this.updateSelectedSlide(), 6000);
    this.setState({ intervalId, isSetInterval: true });
  }

  clearSlidesInterval() {
    clearInterval(this.state.intervalId);
    this.setState({ isSetInterval: false });
  }

  updateSelectedSlide = () => {
    const { children } = this.props;

    this.setState(state => ({
      selected: state.selected === children.length - 1 ? 0 : state.selected + 1
    }))
  };

  handleClick = selected => {
    this.setState({ selected });
    this.clearSlidesInterval();
  };

  render() {
    const { selected } = this.state;
    const { children } = this.props;

    return (
      <section className={styles.root}>
        {children.map((item, index) => (
          index === selected &&
          item
        ))}
        <div className={styles.navigationBlock}>
          {children.map((item, index) => (
            <span key={index} onClick={() => this.handleClick(index)}
                  style={selected === index ? { backgroundColor: '#ff9800' } : null}
                  className={styles.navigationPoint}/>
          ))}
        </div>
      </section>
    )
  }
}

export default CarouselGraphics;
